export interface AzmoonMaharatMain_Interface {
    id:number,
    code:string,
    title:string,


    username:String,
    persianDate:String,
    del:boolean,
  }
  
  export function Empty_AzmoonMaharatMain_Interface():AzmoonMaharatMain_Interface{
    return{
      id:0,
      code:'',
      title:'',

      username:'',
      persianDate:'',
      del:false,
    }
  }